import React from 'react'
import styled from 'styled-components'

const StyledButton = styled.button`
  background-color: #37f091; /* Cor verde */
  color: black; /* Cor do texto */
  font-size: 16px; /* Tamanho do texto */
  padding: 12px 24px; /* Espaçamento interno */
  border: none; /* Sem bordas */
  border-radius: 8px; /* Cantos arredondados */
  cursor: pointer;
  transition:
    background-color 0.2s ease-in-out,
    transform 0.2s ease;

  &:hover {
    background-color: #2cd67b; /* Cor mais escura ao passar o mouse */
  }

  &:active {
    transform: scale(0.98); /* Efeito de clique */
  }
`

export const Button = ({ children, onClick }) => {
  return <StyledButton onClick={onClick}>{children}</StyledButton>
}
